import { ECountry, ELanguage } from 'common/const';

/* Набор языков страницы по стране (US-034, R-1). Порядок — порядок в переключателе. */
const COUNTRY_LANGUAGES: Record<ECountry, ELanguage[]> = {
  [ECountry.RS]: [ELanguage.SR, ELanguage.EN, ELanguage.ES],
  [ECountry.ME]: [ELanguage.CNR, ELanguage.EN],
};

export const getAvailableLanguages = (country: ECountry): ELanguage[] => COUNTRY_LANGUAGES[country];

const isLanguageAvailable = (country: ECountry, language?: string | null): language is ELanguage =>
  !!language && (getAvailableLanguages(country) as string[]).includes(language);

/* Основной язык браузера → язык ME-страницы: сербский (включая sr-ME, sr-Latn-ME)
 *  и черногорский — черногорский, любой другой — английский (O-7). */
export const getMontenegroBrowserLanguage = (browserLanguage?: string | null): ELanguage => {
  const primary = browserLanguage?.split(/[-_]/)[0]?.toLowerCase();

  return primary === ELanguage.SR || primary === ELanguage.CNR ? ELanguage.CNR : ELanguage.EN;
};

interface IResolvePageLanguageParams {
  country: ECountry;
  /** Текущий язык i18next: последний язык страницы; при первом визите — автоопределённый по браузеру (F-4). */
  current?: string | null;
  /** Отметка «язык выбрал гость» (нажатие в переключателе). */
  chosen: boolean;
  /** Основной язык браузера (navigator.languages[0]). */
  browserLanguage?: string | null;
}

/* Язык страницы по действующей стране (US-034, R-2).
 *  RS: как сегодня — последний язык (иначе детектор уже взял язык браузера); отметка не читается (R-14);
 *      оставшийся после ME-страницы черногорский → сербский.
 *  ME: с отметкой — последний язык, если он в наборе ME, иначе черногорский;
 *      без отметки — только по браузеру, последний язык не учитывается (O-7). */
export const resolvePageLanguage = ({ country, current, chosen, browserLanguage }: IResolvePageLanguageParams): ELanguage => {
  if (country === ECountry.ME) {
    if (chosen) {
      return isLanguageAvailable(ECountry.ME, current) ? current : ELanguage.CNR;
    }

    return getMontenegroBrowserLanguage(browserLanguage);
  }

  if (isLanguageAvailable(ECountry.RS, current)) {
    return current;
  }

  // Черногорский вне набора RS — сербский; иное (языка нет) — fallback i18next, английский
  return current === ELanguage.CNR ? ELanguage.SR : ELanguage.EN;
};
